import createLoader from './createLoader';
import loadScript from './loadScript';
var loadStripeCheckout = createLoader(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? 'https://checkout.stripe.com/checkout.js' : _ref$url;

  return loadScript(url);
}, function () {
  return typeof window.StripeCheckout !== 'undefined' ? window.StripeCheckout : null;
});
export default loadStripeCheckout;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/loadStripeCheckout.js
// module id = null
// module chunks = 